// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reschedule-session-modal {
  max-width: 600px !important;
  width: 600px !important;
}
.reschedule-session-modal .modal-content {
  width: 100% !important;
  min-width: 600px;
}
.reschedule-session-modal .modal-body {
  padding: 30px !important;
}
.reschedule-session-modal .calender-select-field,
.reschedule-session-modal .time-select-field {
  width: 100% !important;
}
.reschedule-session-modal .calender-select-field input,
.reschedule-session-modal .time-select-field input {
  width: 100% !important;
  min-width: 100% !important;
}
.reschedule-session-modal form > div {
  width: 100%;
}

@media (max-width: 768px) {
  .reschedule-session-modal {
    max-width: 90% !important;
    width: 90% !important;
    margin: 0 auto;
  }
  .reschedule-session-modal .modal-content {
    min-width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AdminOrTeacherPages/EventsCalendar/components/rescheduleSessionDialog/rescheduleSessionDialog.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,uBAAA;AACF;AACE;EACE,sBAAA;EACA,gBAAA;AACJ;AAEE;EACE,wBAAA;AAAJ;AAGE;;EAEE,sBAAA;AADJ;AAGI;;EACE,sBAAA;EACA,0BAAA;AAAN;AAIE;EACE,WAAA;AAFJ;;AAMA;EACE;IACE,yBAAA;IACA,qBAAA;IACA,cAAA;EAHF;EAKE;IACE,eAAA;EAHJ;AACF","sourcesContent":[".reschedule-session-modal {\n  max-width: 600px !important;\n  width: 600px !important;\n\n  .modal-content {\n    width: 100% !important;\n    min-width: 600px;\n  }\n\n  .modal-body {\n    padding: 30px !important;\n  }\n\n  .calender-select-field,\n  .time-select-field {\n    width: 100% !important;\n\n    input {\n      width: 100% !important;\n      min-width: 100% !important;\n    }\n  }\n\n  form > div {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .reschedule-session-modal {\n    max-width: 90% !important;\n    width: 90% !important;\n    margin: 0 auto;\n\n    .modal-content {\n      min-width: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
